import React, { Component, PropTypes } from 'react'
import {rupiah} from 'utils/formatter'

class RewardRedemptionInfo extends Component {
  render () {
    let { redeemReward, totalRedeemAmount, isRefunded } = this.props
    return (
      <div style={{color: '#444'}} className='top10 row'>
        <div className='col-md-6'>
          <div className='pull-left'>
            Redeemed Reward
          </div>
          <div className='pull-left'>
            {redeemReward}
          </div>
        </div>
        <div className='col-md-6 pull-right'>
          <div className='pull-right'>
            {isRefunded
              ? rupiah(Math.abs(totalRedeemAmount))
              : `(${rupiah(Math.abs(totalRedeemAmount))})`
            }
          </div>
        </div>

      </div>
    )
  }
}

RewardRedemptionInfo.propTypes = {
  isRefunded: PropTypes.bool,
  totalRedeemAmount: PropTypes.number,
  redeemReward: PropTypes.string
}

export default RewardRedemptionInfo



// WEBPACK FOOTER //
// ./app/components/receipt/commons/ListItemBox/RewardRedemptionInfo.js